import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  sentText: {
    color: "#C9BE3B",
    fontSize: "16px",
    fontWeight: 600,
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      textAlign: "left",
    },
  },
  acceptedText: {
    color: theme.palette.success.main,
    fontWeight: 600,
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      textAlign: "left",
    },
  },
  rejectedText: {
    color: theme.palette.error.main,
    textAlign: "left",
    fontWeight: 600,
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      textAlign: "left",
    },
  },
  dateText: {
    marginLeft: theme.spacing(1),
    textAlign: "right",
    fontSize: "16px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "13px",
      textAlign: "left",
    },
  },
  unsentBox: {
    display: "flex",
    alignItems: "center",
    // [theme.breakpoints.down("sm")]: {
    //   flexDirection: "column",
    //   justifyContent: "flex-end",
    // },
    [theme.breakpoints.down("xs")]: {
      flexGrow: 1,
      justifyContent: "space-between",
      //   flexDirection: "row",
    },
  },
  sentBox: {
    display: "flex",
    alignItems: "center",
    // [theme.breakpoints.down("sm")]: {
    //   flexDirection: "column",
    //   justifyContent: "flex-end",
    // },
    [theme.breakpoints.down("xs")]: {
      flexGrow: 1,
      justifyContent: "space-between",
      //   flexDirection: "row",
    },
  },
  buttonText: {
    [theme.breakpoints.down("xs")]: {
      fontSize: "13px",
      lineHeight: 1.3,
    },
  },
}))

export default styles
